/**
 * Resolve or reject a thenable within `ms`.
 * The original work is not cancelled; callers decide how to fall back.
 */
export function withTimeout<T>(promise: PromiseLike<T>, ms: number, label: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error(`${label} timed out`));
    }, ms);

    Promise.resolve(promise).then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}

export function isTimeoutError(error: unknown): boolean {
  return error instanceof Error && error.message.includes('timed out');
}
